import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

const ProtectedRoute = ({ allowedRoles }) => {
  const user = useSelector((state) => state.user.paraAdmin_user_Info);
  const role = user?.role?.toLowerCase()?.trim();

  console.log("🔐 ProtectedRoute user:", user);
  console.log("✅ Allowed roles:", allowedRoles);

  if (!user) {
    return <Navigate to="/" replace />;
  }

  if (!allowedRoles.map((r) => r.toLowerCase()).includes(role)) {
    return (
      <Navigate
        to={role === "admin" ? "/admin-dashboard" : "/dashboard"}
        replace
      />
    );
  }

  return <Outlet />;
};

export default ProtectedRoute;
